import { SingleEvent } from '../third-party-scripts/response-data-validator'

export const getEnabledEvents = (eventsList: SingleEvent[]) =>
    new Set(eventsList.filter((e) => e.enabled).map((e) => e.name))
